import { WeddingEventsActionTypes } from '@bridebook/web/lib/events/action-types';
import { IWeddingEvent } from '@bridebook/models/source/models/Weddings/Events.types';

export const onFirebaseWeddingEvents = (payload: IWeddingEvent[]) => ({
  type: WeddingEventsActionTypes.ON_FIREBASE_WEDDING_EVENTS,
  payload,
});
